import React from 'react';

const UserSettings = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">User Settings</h1>
      <p className="text-gray-600">User settings page coming soon...</p>
    </div>
  );
};

export default UserSettings;
